var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CircularButton",class:( _obj = { '--global-clickable': !_vm.disabled, hasPulse: _vm.pulse }, _obj[(_vm.pulseType + "Anim")] = _vm.pulse, _obj ),on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }